import React from 'react';

import { Field, OptionsList, Option } from '../styles/components';
import OfferDetailsRocContainer from '../../../shared/containers/OfferDetailsRocContainer';
import { Offer } from '../types';
import { EngagementUnit } from '../../../shared/types';
import Checkbox from './Checkbox';

interface MinorOptionsListProps {
  majorOffer: Offer;
  minorOffers: Record<string, Offer>;
  disabledMinorOptionsIds: string[];
  minorProductsEngagementUnit: Record<string, EngagementUnit>;
  setFieldValue: (field: string, value: boolean) => void;
  values: {
    minorsOffers: Record<string, boolean>;
  };
}

const MinorOptionsList: React.FC<MinorOptionsListProps> = ({
  majorOffer,
  minorOffers,
  disabledMinorOptionsIds,
  minorProductsEngagementUnit,
  setFieldValue,
  values
}) => {
  return (
    <OptionsList>
      {Object.values(minorOffers).map(option => {
        const isForbidden = majorOffer.forbiddenOptions.includes(option.id);

        if (isForbidden) {
          return null;
        }

        const isDisabled = disabledMinorOptionsIds.includes(option.id);

        return (
          <Option key={option.id}>
            <Field
              component={Checkbox}
              id={`minorsOffers.${option.id}`}
              name={`minorsOffers.${option.id}`}
              checked={values.minorsOffers?.[option.id] || false}
              onChange={() =>
                setFieldValue(
                  `minorsOffers.${option.id}`,
                  !values.minorsOffers[option.id]
                )
              }
              disabled={isDisabled}
              label={option.title}
            >
              {option.price !== null && option.currency && (
                <OfferDetailsRocContainer
                  price={option.price}
                  currency={option.currency}
                  engagementUnit={
                    minorProductsEngagementUnit[option.id] ?? null
                  }
                  variant="text"
                  isDisabled={isDisabled}
                />
              )}
            </Field>
          </Option>
        );
      })}
    </OptionsList>
  );
};

export default MinorOptionsList;
